import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as requirement from '../requirement'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: requirement.RESOURCE.payload.dimension.partialId,
      partialId: requirement.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Who the Jira task is assigned to.',
    isOptional: true,
    name: 'Assignee',
    partialId: PartialId.Standard.create('assignee'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
